// extracted by mini-css-extract-plugin
export default {"Nav":"Nav_Nav__t+5bX","Link":"Nav_Link__9PRcR","LinkActive":"Nav_LinkActive__YHa+p","navIconSVG":"Nav_navIconSVG__KKIl5","crt":"Nav_crt__UTETt"};